import * as React from "react";
import { makeStyles, Typography, TextField, Chip } from "@material-ui/core";
import { EntityManager } from "src/app/entity.service";
import {
  CrudLoadRequestEvent,
  CrudModifiedEvent,
} from "../../bloc/crud/crud.event";
import { CrudComponent } from "../crud.component";
import { StageBloc } from "./stage.bloc";
import { StageEntity } from "./stage.entity";
import ColorPicker from "material-ui-color-picker";

export interface StageComponentProps {
  entities: EntityManager;
}

const useStyles = makeStyles<any, any>((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  textField: {
    flex: 1,
  },
  textDivider: {
    width: 16,
  },
  addButton: {
    marginTop: 24,
  },
  chip: {
    width: 12,
    height: 12,
    borderRadius: 16,
    marginRight: 8,
    display: "inline-block",
    border: "1px solid #e0e0e0",
    backgroundColor: (props) => props && props.color,
  },
}));

const ColorChip: React.FC<{ color: string }> = ({ color }) => {
  const classes = useStyles({ color });

  return <span className={classes.chip} />;
};

export const StageComponent: React.FC<StageComponentProps> = ({ entities }) => {
  const classes = useStyles({});
  const [bloc] = React.useState(
    new StageBloc(entities).add(new CrudLoadRequestEvent())
  );

  const mapEntityToTitle = (entity: StageEntity) => (
    <Typography className={classes.heading}>
      {entity.colorCode && <ColorChip color={entity.colorCode} />}
      <strong>{entity.name}</strong>
      {entity.isDirty && <i> (niet opgeslagen)</i>}
    </Typography>
  );

  const mapEntityToEditor = (entity: StageEntity) => (
    <React.Fragment>
      <TextField
        variant="outlined"
        label="Omschrijving"
        value={entity.name || ""}
        className={classes.textField}
        onChange={(event) => {
          entity.name = event.target.value;

          bloc.add(new CrudModifiedEvent({ entity }));
        }}
      />

      <div className={classes.textDivider}></div>

      <ColorPicker
        className={classes.textField}
        variant="outlined"
        label="Kleur"
        InputProps={{ value: entity.colorCode }}
        InputLabelProps={{ shrink: !!entity.colorCode }}
        value={entity.colorCode || ""}
        onChange={(color) => {
          entity.colorCode = color.toUpperCase();

          bloc.add(new CrudModifiedEvent({ entity }));
        }}
      />
    </React.Fragment>
  );

  return (
    <CrudComponent
      bloc={bloc}
      renderTitle={(entity: StageEntity) => mapEntityToTitle(entity)}
      renderEditor={(entity: StageEntity) => mapEntityToEditor(entity)}
      saveDisabled={(entity: StageEntity, siblings: StageEntity[]) =>
        !entity.colorCode ||
        !entity.name ||
        !/^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/.test(entity.colorCode) ||
        !!siblings.find((sibling) => sibling.colorCode === entity.colorCode)
      }
    />
  );
};
